import type { AiCoach_Mode as AiCoachMode } from '__generated__/graphql-types';

import type { Coach, CourseItemType } from '@coursera/event-pulse-types';
import { createTrackerStore } from '@coursera/event-pulse/react';

type CoachTrackingData = {
  data: {
    courseId?: string;
    itemId?: string;
    degreeId?: string;
    mode: AiCoachMode;
    location?: Coach['location'];
    itemType?: CourseItemType;
  };
};

const [CoachTrackingDataProvider, useCoachTrackingContext] = createTrackerStore<CoachTrackingData>();

export { CoachTrackingDataProvider, useCoachTrackingContext };
